import React, { useEffect, useState } from 'react';
import { FooterText, NewsLetterStyle } from '../../../StyledComponents';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAddressData, addUserAddress } from '../../../utility/api/services/UserPortal/UserSlice';
import { Col, Row, Spinner } from 'reactstrap';
import Action from '../../../redux/Action';
import AddressBookForm from './AddressBookForm';
import UserPortalService from '../../../utility/api/services/UserPortal/UserService';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)


const AddressBookView = () => {
  const dispatch = useDispatch();
  const selectUserPortal = (state) => state.userPortal;
  const { isLoading, userAddress, error } = useSelector((state) => state.userPortal);

  const [loading, setLoading] = useState(true)
  const [tableData, setTableData] = useState([])
  // const userAddress = useSelector(state=>state.user.usersData)

  const getData = () => {
    dispatch(getUserAddressData())
    setLoading(false)
  }

//   useEffect(()=>{
// dispatch(getUserAddressData())

//   },[])

  useEffect(() => {
    setLoading(true)
            if(userAddress.length==0){
            getData()
        }
  }, [])

  // useEffect(() => {
  // const intervalId = setInterval(() => {
  //   getData();
  // }, 15000); // Call getData every 2 minutes (180000 milliseconds)

  // return () => clearInterval(intervalId); // Cleanup on unmount or re-render
  // }, []);

  useEffect(()=>{

    if(userAddress.length!=0){
        setTableData(userAddress?.data)
        setLoading(false)
    }
  },[userAddress])




  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    street: '',
    apartment: '',
    city: '',
    zipCode: '',
    country: '',
    phone: '',
  });
  const [showForm, setShowForm] = useState(false);

  // useEffect(() => {
    console.log('HEHE',tableData)
  //   dispatch(getUserAddressData());
  // }, []);

  // if (isLoading) {
  //   return <div><Spinner /></div>;
  // }

  const handleAddAddress = (data) => {
    // Dispatch the add address action
    console.log("Address submitted:", data);
    setShowForm(false); // Hide the form after submission
  };

  const handleEditAddress = (address) => {
    setFormData(address); // Set the selected address data to the form
    setShowForm(true); // Show the form
  };

  const handleDelete = async (id) => {
    return MySwal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-danger ms-1'
      },
      buttonsStyling: false
    }).then(function (result) {
        
      if (result.value) {
        UserPortalService.RemoveUserAddress(id)
        .then((response)=> {
          console.log('response',response)
            if(response.success==true){
                MySwal.fire({
                    icon: 'success',
                    title: response.message,
                  //   text: 'Your file has been deleted.',
                    customClass: {
                      confirmButton: 'btn btn-success'
                    }
                  })
                  dispatch(getUserAddressData());
                  setTableData([])
            }else if(response.success==false){
                MySwal.fire({
                    icon: 'warning',
                    // title: 'Please Try Again',
                    title: response.message,
                  //   text: 'Your file has been deleted.',
                    customClass: {
                      confirmButton: 'btn btn-warning'
                    }
                  })
            }
        }).catch((err)=>{
            console.log('ERR', err)
        })
        
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        MySwal.fire({
          title: 'Cancelled',
        //   text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
    })
  }


  const handleDefault = async (id) => {
    return MySwal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Set as Default!',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-warning ms-1'
      },
      buttonsStyling: false
    }).then(function (result) {
        
      if (result.value) {
        UserPortalService.DefaultUserAddress(id)
        .then((response)=> {
          console.log('response',response)
            if(response.success==true){
                MySwal.fire({
                    icon: 'success',
                    title: response.message,
                  //   text: 'Your file has been deleted.',
                    customClass: {
                      confirmButton: 'btn btn-success'
                    }
                  })
                  dispatch(getUserAddressData());
                  setTableData([])
            }else if(response.success==false){
                MySwal.fire({
                    icon: 'warning',
                    // title: 'Please Try Again',
                    title: response.message,
                  //   text: 'Your file has been deleted.',
                    customClass: {
                      confirmButton: 'btn btn-warning'
                    }
                  })
            }
        }).catch((err)=>{
            console.log('ERR', err)
        })
        
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        MySwal.fire({
          title: 'Cancelled',
        //   text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
    })
  }



  return (
    <>
      <div className='p-4'>
        

        {showForm ? (
          <>
          <Row>
            <Col xl='1' lg='1' md='1' sm='12' xs='12' onClick={() => setShowForm(false)}><NewsLetterStyle style={{ fontSize: '18px' }}>Back</NewsLetterStyle></Col>
            <Col xl='11' lg='11' md='11' sm='12' xs='12'>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <NewsLetterStyle style={{ fontWeight: '700' }}>{showForm ? 'Edit Address' : 'Add New Address'}</NewsLetterStyle>
        
        </div>
              <AddressBookForm showState={handleAddAddress} formData={formData} onCancel={() => setShowForm(false)} />
            </Col>
          </Row>
          </>
        ) : (
          <>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <NewsLetterStyle style={{ fontWeight: '700' }}>Address Book</NewsLetterStyle>
        <button
            type='button'
            className='btn'
            style={{ backgroundColor: '#41B8E4', color: 'white' }}
            onClick={() => {
              setFormData({ // Reset formData for new address
                firstName: '',
                lastName: '',
                street: '',
                apartment: '',
                city: '',
                zipCode: '',
                country: '',
                phone: '',
              });
              setShowForm(true);
            }}
          >
            Add Address
          </button> 
        </div>
        {console.log('tableData', tableData)}
        <div className='gap-2' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '1rem' }}>
          {!isLoading && tableData?.filter(address => address.defaultDeliveryAddress)?.map((address) => (
            <div key={address._id} style={{ maxWidth: '466px', width:'100%', border: '1px solid #EC7426', borderRadius: '20px', padding: '1rem', marginBottom:'1rem' }}>
              <div style={{ color: '#EC7426', fontWeight:'700' }}>Default Delivery Address</div>
              <NewsLetterStyle style={{ fontWeight: '600' }}>{`${address.firstName} ${address.lastName}`}</NewsLetterStyle>
              <FooterText>{address.street}</FooterText>
              <FooterText>{`Street no. ${address.apartment}`}</FooterText>
              <FooterText>{`${address.city}, ${address.zipCode}`}</FooterText>
              <FooterText>{address.country}</FooterText>
              <FooterText>{`Phone no. ${address.phone}`}</FooterText>
              <div className='pt-4' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', justifyContent: 'space-around', alignItems:'center' }}>
                <FooterText type='button'
            className='btn' style={{ color: '#EC7426', cursor:'pointer' }}  onClick={() => handleEditAddress(address)}>Edit</FooterText>
                <FooterText style={{ color: '#EC7426', cursor:'pointer' }} onClick={() => handleDelete(address._id)}>Remove</FooterText>
              </div>
            </div>
          ))}
           {!isLoading && tableData?.filter(address => address.defaultBillingAddress)?.map((address) => (
            <div key={address._id} style={{ maxWidth: '466px', width:'100%', border: '1px solid #EC7426', borderRadius: '20px', padding: '1rem', marginBottom:'1rem' }}>
              <div style={{ color: '#EC7426', fontWeight:'700' }}>Default Billing Address</div>
              <NewsLetterStyle style={{ fontWeight: '600' }}>{`${address.firstName} ${address.lastName}`}</NewsLetterStyle>
              <FooterText>{address.street}</FooterText>
              <FooterText>{`Street no. ${address.apartment}`}</FooterText>
              <FooterText>{`${address.city}, ${address.zipCode}`}</FooterText>
              <FooterText>{address.country}</FooterText>
              <FooterText>{`Phone no. ${address.phone}`}</FooterText>
              <div className='pt-4' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', justifyContent: 'space-around', alignItems:'center' }}>
                <FooterText type='button'
            className='btn' style={{ color: '#EC7426', cursor:'pointer' }}  onClick={() => handleEditAddress(address)}>Edit</FooterText>
                <FooterText style={{ color: '#EC7426', cursor:'pointer' }} onClick={() => handleDelete(address._id)}>Remove</FooterText>
              </div>
            </div>
          ))}
        </div>
        <div className='gap-2' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '1rem' }}>
          {!isLoading && tableData?.filter(address => !address.defaultBillingAddress && !address.defaultDeliveryAddress)?.map((address) => (
            <div key={address._id} style={{ maxWidth: '466px', width:'100%', border: '1px solid #d9d9d9', borderRadius: '20px', padding: '1rem' }}>
              <NewsLetterStyle style={{ fontWeight: '600' }}>{`${address.firstName} ${address.lastName}`}</NewsLetterStyle>
              <FooterText>{address.street}</FooterText>
              <FooterText>{`Street no. ${address.apartment}`}</FooterText>
              <FooterText>{`${address.city}, ${address.zipCode}`}</FooterText>
              <FooterText>{address.country}</FooterText>
              <FooterText>{`Phone no. ${address.phone}`}</FooterText>
              <div className='pt-4' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', justifyContent: 'space-around', alignItems:'center' }}>
                <FooterText type='button'
            className='btn' style={{ color: '#EC7426', cursor:'pointer' }}  onClick={() => handleEditAddress(address)}>Edit</FooterText>
                <FooterText style={{ color: '#EC7426', cursor:'pointer' }} onClick={() => handleDelete(address._id)}>Remove</FooterText>
                <FooterText style={{ color: '#EC7426', cursor:'pointer' }} onClick={() => handleDefault(address._id)}>Set as Default</FooterText>
              </div>
            </div>
          ))}
        </div>
          </>

        )
      }


      </div>
    </>
  );
};

export default AddressBookView;
